<template>
  <div>
    <div class="mb-1">
      <strong>
        {{ (professionalType === 'new') ? $t('message.no_datetime_booking.select_new_service_provider') : $t('message.no_datetime_booking.select_used_service_provider') }}
      </strong>
    </div>
    <section v-if="professionals.length > 0">
      <div v-for="professional in professionals">
        <div class="card">
          <div class="card-body text-left">
            <div class="d-flex ustify-content-start align-items-top">
              <div>
                <professional-picture :professional="professional" :imgSize="48"/>
              </div>
              <div class="flex-fill px-3 text-left">
                <div class="w-100">
                  <h3 class="m-0">{{ professional.name | firstName }}</h3>
                </div>
                <div class="mt-1 text-small">
                  <i class="fas fa-star text-warning"/> {{ Number(professional.rating).toFixed(2) }} 
                  <span v-if="professional.rating_qty">({{ professional.rating_qty }})</span>
                  ·
                  <span>
                    {{ globalState.cities[professional.province_id] | multiLangName }}
                  </span>
                </div>
              </div>
              <div v-if="professional.distance">
                {{ professional.distance | distance }}
              </div>
            </div>
            <div class="mt-2 text-small" v-if="professional.is_excellent === 1">
              <router-link to="/excellent-provider">
                <img src="/static/img/ic_badge_excellent.png"
                      width="18"
                      v-b-popover.hover.top="$i18n.t('message.professional.excellent_provider_detail', {name: firstName(professional.name)})"
                      :title="$i18n.t('message.professional.excellent_provider_title')">
              </router-link>
              {{ $t('message.professional.excellent_provider_title') }}
            </div>
            <div class="mt-2 text-small" v-if="professional.spoken_languages.length > 0">
              <i class="fas fa-comments"></i> {{ professional.spoken_languages }}
            </div>
          </div>
          <div class="d-flex justify-content-end pr-3 pb-3">
            <div>
              <button class="btn btn-info px-3" @click="selectProfessional(professional)">
                {{ $t('message.company_address.choose') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-3" v-if="canLoadMore">
        <button class="btn btn-outline-info btn-block" @click="loadMoreProfessionals()" :disabled="isLoading">
          {{ isLoadingProfessionals ? $t('message.button.loading') : $t('message.button.load_more') }}
        </button>
      </div>
    </section>
    <section class="text-center" v-else>
      <div v-if="isLoadingProfessionals">
        <loader></loader>
      </div>
      <div v-else>
        {{ $t('message.professional.no_service_provider') }}
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Loader from '../../loader/Loader'
  import ProfessionalPicture from '../../professional/components/ProfessionalPicture'
  import axios from 'axios'

  export default {
    props: {
      order: Object,
      userPlace: Object
    },
    components: {
      Loader,
      ProfessionalPicture
    },
    data () {
      return {
        professionalType: 'new',
        page: 0,
        limit: 10,
        professionals: [],
        isLoadingProfessionals: false,
        canLoadMore: true,
        userPlaceId: 0
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      init (professionalType) {
        this.professionalType = professionalType
        this.userPlaceId = this.userPlace.id
        this.page = 0
        this.professionals = []
        this.fetchProfessionals()
      },
      firstName (name) {
        return this.$options.filters.firstName(name)
      },
      async fetchProfessionals () {
        this.isLoadingProfessionals = true
        if (this.page === 0) {
          this.professionals = []
        } else {
          const lastIndex = this.professionals.length - 1
          if (this.professionals[lastIndex] === null) {
            this.professionals.pop()
          }
        }
        let url = null
        let params = null
        // Fetch have used service professionals
        if (this.professionalType === 'usedService') {
          url = `/users/${this.user.id}/professionals`
          params = {
            order_id: this.order.id,
            service_id: this.parentServiceId,
            province_id: this.order.province_id,
            user_place_id: this.userPlace.id,
            page: this.page,
            limit: this.limit
          }
        } else {
          // Fetch new professionals
          url = `/professionals`
          params = {
            user_id: this.user.id,
            user_place_id: this.userPlace.id,
            province_id: this.order.province_id,
            service_id: this.parentServiceId,
            work_hour: this.order.work_hour,
            page: this.page,
            limit: this.limit
          }
          if (this.order.extra && this.order.extra.service_id) {
            params.extra_service_id = this.order.extra.service_id
          }
        }
        const {data} = await axios.get(url, {params})
        this.isLoadingProfessionals = false
        if (!data.error) {
          this.canLoadMore = data.professionals.length === this.limit
          if (this.page === 0) {
            this.professionals = data.professionals
          } else {
            this.professionals = this.professionals.concat(data.professionals)
          }
        }
      },
      loadMoreProfessionals () {
        this.page += 1
        this.fetchProfessionals()
      },
      selectProfessional (professional) {
        this.$emit('onSelected', professional)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/order/components/SelectProfessional.vue